import {ref, type Ref} from "vue";

/**
 * Saniye bazlı geri sayım timer'ı.
 * setTimeout gecikmelerini telafi ederek daha doğru zamanlama sağlar.
 */
export class TimerService {
  timerID: ReturnType<typeof setTimeout> | null = null;
  remainingTime: Ref<number> = ref(0);
  previoustime = performance.now();
  interval = 1000; // ms
  totalDelay = 0;
  stepCallback: (() => void) | null = null;
  completeCallback: (() => void) | null = null;

  constructor(
    time: Ref<number>,
    stepCallback?: (() => void) | null,
    completeCallback?: (() => void) | null,
  ) {
    this.remainingTime = time;
    this.stepCallback = stepCallback ?? null;
    this.completeCallback = completeCallback ?? null;
  }

  start(): void {
    this.stop();

    this.previoustime = performance.now();
    this.totalDelay = 0;
    this.timerID = setTimeout(this.step, this.interval);
  }

  stop(): void {
    if (!this.timerID) return;

    this.totalDelay = 0;
    clearTimeout(this.timerID);
    this.timerID = null;
  }

  step: () => void = () => {
    // Gerçekte ne kadar süre geçtiğini ölç
    const elapsed = performance.now() - this.previoustime;
    // setTimeout'un ne kadar geciktiğini hesapla
    const delta = elapsed - this.interval;
    this.delayFix(delta);

    if (this.remainingTime.value <= 1) {
      this.remainingTime.value = 0;
      this.stop();
      this.completeCallback?.();
      return;
    }

    this.previoustime = performance.now();
    this.remainingTime.value -= 1;
    this.timerID = setTimeout(this.step, this.interval);
    this.stepCallback?.();
  };

  /**
   * Birikmiş gecikmeleri telafi eder.
   * Her step'teki küçük gecikmeler toplanır, 1 saniyeyi geçince kalan süreden düşülür.
   * Örn: Her step 50ms gecikirse, 20 step sonra 1 saniye telafi edilir.
   */
  delayFix(delay: number): void {
    if (delay <= 0) return;
    this.totalDelay += delay;
    // 1 saniye biriktirene kadar bekle
    if (this.totalDelay < 1000) {
      return;
    }
    // Biriken gecikmeyi saniyeye çevir ve kalan süreden düş
    const t = Math.floor(this.totalDelay / 1000);
    this.remainingTime.value = Math.max(0, this.remainingTime.value - t);
    this.totalDelay -= t * 1000;
  }
}
